/**
 *
 * Container: Configs
 * Date: 2/7/2020
 *
 */

import React, { useEffect, useReducer } from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import { EmptyState } from 'components/common';
import VisualConfig from 'components/VisualConfig';
import toast from 'components/common/Message';
import { configReducer, initialState } from './reducer';
import { IS_LOADING, SET_CONFIG } from './constants';
import { getConfig, postConfig } from './api';
import action from './actions';

/**
 * Renders appropriate Drag and Drop - able Config Components based on configId.
 * @returns {JSX}
 */
export const Configs = ({ configId = 'visualsConfiguration' }: any) => {
  const [{ loading, config, configSchema }, dispatch] = useReducer(
    configReducer,
    initialState,
  );

  const handleModifyConfig = (newConfig: any) => {
    postConfig(newConfig, (result: string) => {
      if (result) toast('Config Saved', 'success');
      else toast('Encountered an error while saving', 'error');
    });
  };

  const handleFetchList = () => {
    dispatch(action(IS_LOADING));
    getConfig((fetchedConfigs: any) => {
      // loading gets removed on response
      dispatch(action(SET_CONFIG, fetchedConfigs));
    });
  };

  useEffect(() => {
    handleFetchList();
  }, []);

  const getConfigsList = (id: string) => {
    let configJSX = <div />;
    if (id === 'visualsConfiguration')
      configJSX = (
        <DndProvider backend={HTML5Backend as any}>
          <VisualConfig
            loading={loading}
            configs={{ config, configSchema }}
            fetchList={handleFetchList}
            modifyConfig={handleModifyConfig}
          />
        </DndProvider>
      );
    else
      configJSX = (
        <EmptyState message="You are not authorized, mail us at support@prodigaltech.com to get access" />
      );
    return configJSX;
  };
  return getConfigsList(configId);
};

export default Configs;
